import { Component, Input, ViewChild } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { ReasonType } from 'enums/ReasonType';
import { SelectListItemModel } from 'models/SelectList';
import { ReasonModel } from 'models/generated/Entities.GormCrm.Reason';
import { ReasonCategoryModel } from 'models/generated/Entities.GormCrm.ReasonCategory';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { ReasonService } from 'services/reason.service';

@Component({
	selector: 'view-reason',
	templateUrl: './view-reason.component.html',
	providers: [FormValidationService],
	imports: [Layout, CustomInputComponent, CustomSelectComponent, TranslatePipe]
})
@CredentialRequired(CredentialType.EditReasons)
export class ViewReasonComponent {

	@ViewChild('saveButton') saveButton!: SubmitButtonComponent;

	private _reason = new ReasonModel();
	public reasonCategories: ReasonCategoryModel[] = [];
	public selectReasonCategories?: SelectListItemModel[];
	public selectedReasonCategoryId?: string = undefined;

	public inputType = InputType;
	public reasonType = ReasonType;
	types: { reasonType: ReasonType, key: string, enabled: boolean }[] = [];
	objectionType:  { reasonType: ReasonType, key: string, enabled: boolean } | undefined;
	setOnHold = false;

	@Input()
	set reason(reason: ReasonModel) {
		this._reason = reason;
		this.setOnHold = (this.reason.onHoldTypes && (this.reason.types & this.reasonType.Objection) && (this.reason.onHoldTypes & this.reasonType.Objection))! > 0;
		this.reason.onHoldTypes = (this.setOnHold && (this.reason.types & this.reasonType.Objection)) ? ReasonType.Objection : undefined;
		this.selectedReasonCategoryId = reason.categoryId;
		this.getCategories();
		this.setEnabledTypes();
	}
	get reason() {
		return this._reason!;
	}

	constructor(private readonly reasonService: ReasonService) {
		Array.from(ReasonType.getKeys()).forEach(type => {
			if (type[0] > 0) this.types.push({ reasonType: type[0], key: type[1], enabled: false });
		});
		this.objectionType = this.types.filter(t => t.reasonType == ReasonType.Objection)[0];
	}

	private getCategories() {
		this.reasonService.getAllReasonCategories().then(categories => {
			this.selectReasonCategories = categories.map(category => new SelectListItemModel(category.id!, category.name));
			this.reasonCategories = categories;
		});
	}
	private setEnabledTypes() {
		this.types.forEach(type => {
			type.enabled = (this.reason.types & type.reasonType) > 0;
		});
	}

	save() {
		this.reason.categoryId = this.selectedReasonCategoryId ? this.selectedReasonCategoryId : undefined;
		this.reason.types = this.types.filter(type => type.enabled).map(type => type.reasonType).reduce((types, type) => types | type, ReasonType.None);
		this.reason.onHoldTypes = (this.setOnHold && (this.reason.types & this.reasonType.Objection)) ? ReasonType.Objection : undefined;
		this.reasonService.saveReason(this.reason).then(_ => this.saveButton.succeeded());
	}
}
